<template lang="pug">
    #taxes-select
        v-select.taxes-selector(v-model="select" solo dense outlined small-chips multiple :hide-details="hideDetails" deletable-chips return-object :items="items" item-text="text" item-value="id"  :placeholder="$t('Products.__SelectTax')" :menu-props="{ bottom: true, offsetY: true }" )
            template(v-slot:append-item v-if="insertTag")
                v-divider
                v-list-item.text-left(@click="addTaxDialog=true")
                    v-list-item-avatar
                        v-icon add
                    v-list-item-content
                        v-list-item-title {{$t("Taxes.__AddTax")}}
        EditTaxDialog(v-model="addTaxDialog" :edit-type="1" :done-action="insertDoneAction")
</template>
<script>
import EditTaxDialog from "@/components/dialogs/EditTaxDialog"

export default {
  components: { EditTaxDialog },
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    insertTag: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      addTaxDialog: false,
      search: null,
      items: [],
      select: null,
      taxes: []
    }
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val)
    },
    value(val) {
      this.select = val
    },
    select(val) {
      if (val) {
        this.$emit("input", val)
      }
    }
  },
  methods: {
    getTaxes(taxId) {
      this.$store
        .dispatch("taxes/getTaxes")
        .then(
          function(response) {
            this.items = this.taxes = response.data
            // taxItems
            for (var item of this.items) {
              item.text = item.name + " " + item.rate + "%"
              if (item.id == taxId) {
                this.select.push(item)
              }
            }
          }.bind(this)
        )
        .catch(function(error) {}.bind(this))
    },
    findTax(id) {
      return this.taxes.find(element => element.id == id)
    },
    querySelections(val) {
      this.items = this.taxes.filter(item => {
        return (
          (item.name || "").toLowerCase().indexOf((val || "").toLowerCase()) > -1 ||
          (item.code || "").toLowerCase().indexOf((val || "").toLowerCase()) > -1
        )
      })
    },
    insertDoneAction(taxId) {
      this.getTaxes(taxId)
    }
  },
  mounted() {
    this.getTaxes()
    this.select = this.value
  }
}
</script>
